import React from 'react'

import { Dialog, Switch } from '@headlessui/react'
import { Fragment } from 'react'
import { Transition } from '@headlessui/react'
import Button from '@components/ui/AddButton'
import { Cross } from '@components/icons'
import {
  ICustomAttribute,
  IProduct,
} from '@components/utils/model/product.model'
import { ISizeChart } from '../hook/sizeInLine.hook'
import { IDeviceInfo } from '@components/ui/context'
import { Skeleton } from '@components/ui'
import { matchStrings, priceFormat } from '@framework/utils/parse-util'
import { GroupedData } from '@framework/utils/lodash'

interface IProps {
  isSizeChart: boolean
  product: IProduct
  SizeChart: ISizeChart
  isImageLoaded: boolean
  deviceInfo: IDeviceInfo
  isSizeChange: boolean
  enabled: boolean
  currentVariantData: any
  currentAttribute: string | undefined
  selectedSizeProduct: any
  allowCart: boolean
  attrGroup: GroupedData<ICustomAttribute>
  selectedSizeInLineProduct: any
  selectedSizeInLineProductDiscount: number
  selectedSizeProductDiscount: any
  callToAction: any
  isInWishList: any
  handleWishList: () => void
  setDisabled: () => void
  setEnable: () => void
  setIsImageLoaded: (payload: boolean) => void
  setSizeChart: (payload: boolean) => void
  handleChange: (item: any) => void
  handleChangeFromSizeChart: (size: any) => any
  sanitizeSize: (value: string) => string
  isVisible: () => boolean
}
const SizeInLineTransition = ({
  isSizeChart,
  product,
  SizeChart,
  currentAttribute,
  currentVariantData,
  isImageLoaded,
  selectedSizeInLineProduct,
  selectedSizeInLineProductDiscount,
  deviceInfo,
  isSizeChange,
  enabled,
  attrGroup,
  allowCart,
  selectedSizeProduct,
  selectedSizeProductDiscount,
  isInWishList,
  callToAction,
  handleWishList,
  isVisible,
  setSizeChart,
  setIsImageLoaded,
  setDisabled,
  setEnable,
  handleChange,
  handleChangeFromSizeChart,
  sanitizeSize,
}: IProps) => {
  const { isOnlyMobile } = deviceInfo
  return (
    <Transition.Root show={isSizeChart} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-9999"
        onClose={() => setSizeChart(false)}
      >
        <div className="fixed inset-0 left-0 bg-black/[.5]" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="fixed inset-y-0 right-0 flex max-w-full pointer-events-none">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-400"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-400"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="w-screen max-w-md pointer-events-auto side-panel-lg">
                  <div className="relative z-50 flex flex-col h-full bg-white shadow-xl">
                    <div className="px-0 py-3 sm:px-0">
                      <div className="flex pb-2 border-b border-gray-200">
                        <button
                          type="button"
                          className="mr-2 text-black bg-white rounded-md outline-none hover:text-gray-500 mob-alignment-btn"
                          onClick={() => setSizeChart(false)}
                        >
                          <div className="inline-block px-6">
                            <Cross
                              className="relative w-6 h-6 text-zinc-600 -top-1"
                              aria-hidden="true"
                            />
                          </div>
                          <div className="inline-block text-left">
                            <span className="flex-1 text-lg font-bold text-black">
                              Size Chart
                            </span>
                            <span className="flex-1 block text-sm text-gray-500">
                              {product.name}
                            </span>
                          </div>
                        </button>
                      </div>
                    </div>
                    <div className="pt-4 overflow-y-auto sizeChart pb-40">
                      <>
                        {SizeChart?.Images?.map((chart: any, iid: any) => {
                          return (
                            <div key={iid}>
                              <div
                                className={`flex flex-col px-4 sm:px-12 ${
                                  !isImageLoaded ? 'hidden' : ''
                                } image-container`}
                              >
                                <img
                                  alt={chart?.name}
                                  src={chart?.ImageUrl}
                                  className="image"
                                />
                              </div>
                              {!isImageLoaded && (
                                <div className="flex flex-col px-4 sm:px-10">
                                  <Skeleton
                                    height={`${
                                      deviceInfo?.isOnlyMobile
                                        ? '14rem'
                                        : '20rem'
                                    }`}
                                    width="100%"
                                    style={{
                                      width: '100%',
                                      marginTop: '5px',
                                      borderRadius: '5px',
                                      background: 'rgba(0, 0, 0, 0.11)',
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          )
                        })}
                        <div className="flex justify-between px-4 pb-3 mt-3 border-b border-gray-200 sm:px-10">
                          <div className="mt-1 item-left">
                            <h3 className="text-base font-medium text-gray-dark">
                              Select a size to add to bag
                            </h3>
                          </div>
                          {isSizeChange ? (
                            <>
                              <div className="item-right">
                                <Switch
                                  checked={enabled}
                                  onChange={() => setDisabled()}
                                  className={`${
                                    enabled ? 'bg-white' : 'bg-white'
                                  } relative inline-flex switch-panel-parent transition-colors duration-200 dark:text-black ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 switch-in-before`}
                                >
                                  <span
                                    aria-hidden="true"
                                    className={`${
                                      enabled
                                        ? 'translate-x-10'
                                        : 'translate-x-0'
                                    } switch-panel inline-block ring-0 transition duration-200 dark:text-black ease-in-out`}
                                  >
                                    cm
                                  </span>
                                </Switch>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="item-right">
                                <Switch
                                  checked={enabled}
                                  onChange={() => setEnable()}
                                  className={`${
                                    enabled ? 'bg-white' : 'bg-white'
                                  } relative inline-flex switch-panel-parent transition-colors duration-200 dark:text-black ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 switch-cm-before`}
                                >
                                  <span
                                    aria-hidden="true"
                                    className={`${
                                      enabled
                                        ? 'translate-x-5 border-black'
                                        : 'translate-x-0'
                                    } switch-panel inline-block ring-0 transition dark:text-black duration-200 ease-in-out`}
                                  >
                                    in
                                  </span>
                                </Switch>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="flex flex-col">
                          <table className="w-full bg-white border-b border-gray-200">
                            <thead>
                              <tr>
                                <th
                                  className={`py-2 ${
                                    deviceInfo?.isOnlyMobile ? 'pl-4' : 'pl-10'
                                  } text-sm font-medium text-left border-b border-r border-gray-200 text-gray-dark`}
                                  style={{
                                    width: `calc(100% / ${
                                      SizeChart?.SizesToDisplay?.length + 1
                                    })`,
                                  }}
                                >
                                  <span>Size</span>
                                </th>
                                {SizeChart?.SizesToDisplay?.map(
                                  (item: any, ind: any) => {
                                    return (
                                      <th
                                        id={ind}
                                        key={ind}
                                        className="py-2 text-sm font-medium text-black border-b border-gray-200"
                                        style={{
                                          width: `calc(100% / ${
                                            SizeChart?.SizesToDisplay?.length +
                                            1
                                          })`,
                                        }}
                                      >
                                        <span className="block">{item}</span>
                                        <span className="block text-xs text-gray-400">
                                          {!isSizeChange ? '(inches)' : '(cm)'}
                                        </span>
                                      </th>
                                    )
                                  }
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {SizeChart?.Sizes?.map((data: any, did: any) => {
                                return (
                                  <tr key={did}>
                                    <td
                                      align="left"
                                      className={`py-3 ${
                                        deviceInfo?.isOnlyMobile
                                          ? 'pl-4'
                                          : 'pl-10'
                                      } font-medium text-left text-black border-b border-r border-gray-200 text-md`}
                                    >
                                      <input
                                        onClick={() =>
                                          handleChange(
                                            handleChangeFromSizeChart(data.Size)
                                          )
                                        }
                                        type="radio"
                                        id={`size_${data.Size}`}
                                        className="bg-gray-100 border border-gray-200"
                                        value={data.Size}
                                        name="size"
                                        defaultChecked={matchStrings(
                                          currentVariantData
                                            ? currentVariantData
                                            : currentAttribute,
                                          sanitizeSize(data.Size),
                                          true
                                        )}
                                      />
                                      <label
                                        htmlFor={`size_${data.Size}`}
                                        className="relative pl-4 font-light leading-none align-text-bottom text-md text-gray-dark"
                                      >
                                        {data.Size}
                                      </label>
                                    </td>
                                    {SizeChart?.SizeKeyToDisplay?.map(
                                      (_i: any, i: any) => {
                                        return (
                                          <td
                                            className="py-3 text-sm font-light text-center text-gray-dark"
                                            id={i}
                                            key={i}
                                          >
                                            <span>
                                              {!isSizeChange
                                                ? data?.[_i + 'Inches']
                                                : data?.[_i + 'Cms']}
                                            </span>
                                          </td>
                                        )
                                      }
                                    )}
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </>
                      <div className="fixed bottom-0 z-10 flex flex-col w-full pt-2 pb-4 bg-white border-t border-gray-200">
                        <div className="flex justify-between px-4 pt-2 sm:pt-6 sm:px-12">
                          <div className="item-left">
                            <div className="flex item-left">
                              <div className="flex justify-around font-semibold text-primary text-16">
                                {currentVariantData ||
                                  (attrGroup['clothing.size']?.[0] as any)
                                    ?.value}
                              </div>
                              <span className="flex justify-around mx-1 text-brown-light text-12">
                                {' '}
                                •{' '}
                              </span>
                              <div className="flex justify-around font-semibold text-primary text-16">
                                {selectedSizeProduct?.variantGroupCode?.replace(
                                  `${product?.productCode}-`,
                                  ''
                                ) ||
                                  (attrGroup['global.colour']?.[0] as any)
                                    ?.valueText +
                                    '-' +
                                    (
                                      attrGroup['global.colour'][0] as any
                                    )?.fieldText?.split('|')?.[0]}
                              </div>
                            </div>
                          </div>

                          {allowCart && (
                            <div className="item-right">
                              <p className="font-semibold text-black text-14 sm:text-md">
                                {priceFormat(
                                  selectedSizeInLineProduct?.price?.raw?.withTax
                                )}

                                {selectedSizeInLineProduct?.listPrice?.raw
                                  ?.withTax >
                                selectedSizeInLineProduct?.price?.raw
                                  ?.withTax ? (
                                  <>
                                    <span className="px-2 text-sm font-normal line-through text-brown-light sm:text-md">
                                      {priceFormat(
                                        selectedSizeInLineProduct?.listPrice
                                          ?.raw?.withTax
                                      )}
                                    </span>
                                    {selectedSizeInLineProductDiscount > 0 && (
                                      <span className="text-sm font-semibold text-green sm:text-md">
                                        {selectedSizeProductDiscount}% off
                                      </span>
                                    )}
                                  </>
                                ) : null}
                              </p>
                            </div>
                          )}
                        </div>

                        {isVisible() && allowCart && (
                          <div className="flex px-4 mt-2 sm:px-12">
                            <button
                              type="button"
                              className="flex items-center justify-center shadow-lg px-4 py-3 -mr-0.5 w-20 text-black bg-white border-2 border-black quick-wishlist-border rounded-sm hover:bg-red-100 hover:text-orange-500 sm:px-6 hover:border-orange-600"
                              onClick={() => {
                                if (!isInWishList) {
                                  handleWishList()
                                }
                              }}
                            >
                              {isInWishList ? (
                                <i className="sprite-icon sprite-o-whislist"></i>
                              ) : (
                                <i className="sprite-icon sprite-whislist"></i>
                              )}
                            </button>
                            <div
                              className="w-full shadow-lg"
                              onClick={() => setSizeChart(false)}
                            >
                              <Button
                                className="w-full"
                                title={callToAction?.title}
                                validateAction={callToAction?.validateAction}
                                action={callToAction?.action}
                                buttonType={callToAction?.type || 'cart'}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default SizeInLineTransition
